import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationComponent } from './confirmation.component';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '../button/button.module';
import { ModalModule } from '@challenger6/vm-pattern-library/modal';
import { LinkModule } from '@challenger6/vm-pattern-library/link';
import { MarkdownModule } from 'ngx-markdown';
import { LiveChatService } from '../../../../src/lib/services/live-chat.service';
import { GenericTilesModule } from '../generic-tiles/generic-tiles.module';
import { LiveChatV3Module } from '../../directives/live-chat-v3';
import { MediaModule } from '@challenger6/vm-pattern-library/media';

@NgModule({
  declarations: [ConfirmationComponent],
  exports: [ConfirmationComponent],
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    LinkModule,
    ModalModule,
    MarkdownModule,
    MediaModule,
    LiveChatV3Module,
    GenericTilesModule,
  ],
  providers: [LiveChatService],
})
export class ConfirmationModule {}
